import { useDeviceCategoryUrlParams } from "@host/composables/url-params/useDeviceCategoryUrlParams";
import { usePeriodUrlParams } from "@host/composables/url-params/usePeriodUrlParams";
import { usePresetUrlParams } from "@host/composables/url-params/usePresetUrlParams";

export function useUrlParams() {
  const { deviceCategoryFromUrl, setDeviceCategoryToUrl } = useDeviceCategoryUrlParams();
  const { periodFromUrl, setPeriodToUrl, isValidPeriodFromUrl } = usePeriodUrlParams();
  const { presetFromUrl, setPresetToUrl } = usePresetUrlParams();

  return {
    deviceCategoryFromUrl,
    setDeviceCategoryToUrl,
    periodFromUrl,
    setPeriodToUrl,
    isValidPeriodFromUrl,
    presetFromUrl,
    setPresetToUrl,
  };
}
